import client from "@/client/publicApiClient.ts";
import type { ResponseConfig } from "@/client/publicApiClient.ts";
import type { GetCurrentIdentityQueryResponse } from "../types/GetCurrentIdentity";

 /**
 * @description Returns the identity of the current user
 * @summary Get
 * @link /api/identity
 */
export async function getCurrentIdentity(options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetCurrentIdentityQueryResponse>["data"]> {
    const res = await client<GetCurrentIdentityQueryResponse>({ method: "get", url: `/api/identity`, ...options });
    return res.data;
}